<!-- display-desktop-11 preview — a display ad in the right rail of a desktop
     publisher page, on the same stand-in page as the other desktop placements:
     a serif wordmark, a nav row with the site tools opposite it, then the
     article. The article does not run the page's full width here — it keeps its
     column on the left and the ad sits in a rail beside it. The unit is the one
     rail card that shows no creative at all: Google's text-only rendition, where
     the advertiser's mark shares the top row with a headline set large over two
     lines, then a three-line description, the advertiser's name, and a filled
     pill button across the full width of the card. -->
<app-desktop-frame>
  <!-- START: Publisher page -->
  <div class="da-page">
    <!-- The site account button, tight against the top of the window. -->
    <div class="da-account d-flex justify-content-end">
      <i class="bi bi-person-circle" aria-hidden="true"></i>
    </div>

    <!-- The publisher wordmark. A stand-in logo, so it is set as text. -->
    <div class="da-wordmark">website</div>

    <!-- Site nav on the left, site tools on the right. -->
    <div class="da-nav d-flex flex-row align-items-start">
      <span
        *ngFor="let item of navItems"
        class="da-nav-item placeholder"
        aria-hidden="true"
      ></span>

      <div class="da-tools d-flex flex-row align-items-center ms-auto">
        <i class="bi bi-search" aria-hidden="true"></i>
        <i class="bi bi-arrow-clockwise" aria-hidden="true"></i>
        <i class="bi bi-share" aria-hidden="true"></i>
        <i class="bi bi-envelope" aria-hidden="true"></i>
        <i class="bi bi-rss" aria-hidden="true"></i>
      </div>
    </div>

    <!-- The article column and the ad rail beside it. -->
    <div class="da-content d-flex flex-row">
      <!-- The article the ad sits beside, and the lead image the window cuts
           off. Same skeleton as the placements that run above the article, just
           in a narrower share of the page. -->
      <div class="da-article">
        <div class="da-bars d-flex flex-column">
          <span
            *ngFor="let bar of bodyBars; let last = last"
            class="da-bar placeholder"
            [class.da-bar-short]="last"
            aria-hidden="true"
          ></span>
        </div>

        <div class="da-block" aria-hidden="true"></div>
      </div>

      <!-- START: Real ad -->
      <div class="da-ad">
        <!-- The AdChoices badge is chrome the network draws over the unit, so it
             is decorative here. Nothing else in this card comes from Google —
             there is no dismiss control on this placement. -->
        <span
          class="da-adchoices d-flex align-items-center justify-content-center"
        >
          <i class="bi bi-info-circle" aria-hidden="true"></i>
        </span>

        <div class="da-card-body">
          <!-- The mark and the headline share the top row, the mark in a fixed
               column of its own so the headline starts in the same place
               whatever the mark's proportions. -->
          <div class="da-header d-flex flex-row">
            <!-- GenSingleImagePreviewData carries no logo field, so the mark is
                 the Valamar asset rather than an authored one, the same
                 compromise the other placements make. -->
            <div class="da-brand">
              <img *ngIf="data.logo" class="da-logo" [src]="data.logo" alt="" />
              <span *ngIf="!data.logo" class="da-logo logo-empty" aria-hidden="true"></span>
            </div>

            <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-headline">
              {{ data.headlines[0] || "Your headline appears here" }}
            </a>
          </div>

          <div class="da-desc">
            {{ data.descriptions[0] || "Your description appears here" }}
          </div>

          <!-- The mock names the advertiser here rather than showing a mark a
               second time. GenSingleImagePreviewData carries no advertiser
               field, so the name is a literal here, the same compromise the
               other placements make. -->
          <div class="da-advertiser">Valamar</div>

          <!-- The call to action is a filled pill across the full width of the
               card, with the label and its chevron centred as a pair. -->
          <a
            [href]="data.url" target="_blank" rel="noopener noreferrer"
            class="da-cta d-flex align-items-center justify-content-center"
          >
            <span class="da-cta-label">
              {{ data.ctaText || "Your call to action" }}
            </span>
            <i class="bi bi-chevron-right" aria-hidden="true"></i>
          </a>
        </div>
      </div>
      <!-- END: Real ad -->
    </div>
  </div>
  <!-- END: Publisher page -->
</app-desktop-frame>
